import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CreNgConfig, CreNgModule } from 'cre-ng';
import { UserIdleConfig, UserIdleModule } from 'angular-user-idle';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

import { AppRoutingModule } from '@app/app-routing.module';
import { AppComponent } from '@app/app.component';
import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';
import { W4formModule } from '@app/w4-form/w4form.module';
import { RestInterceptor } from './core/rest.interceptor';

// Environment settings are configured when the app is initializing
export const creNgConfig: CreNgConfig = {
  idleCheck: window.__env.ngSettings.idleCheck,
  idleSeconds: window.__env.ngSettings.idleSeconds,
  idleTimeout: window.__env.ngSettings.idleTimeout,
  serviceApiDomain: window.__env.ngSettings.serviceApiDomain,
  session: window.__env.ngSettings.session,
  sessionAppName: window.__env.ngSettings.sessionAppName, // <== Must be set. Not environment related.
  sessionSeconds: window.__env.ngSettings.sessionSeconds,
};

export const userIdleConfig: UserIdleConfig = {
  idle: creNgConfig.idleSeconds,
  timeout: creNgConfig.idleTimeout,
  ping: 0,
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CoreModule,
    ConfirmDialogModule,
    CreNgModule.forRoot(creNgConfig),
    SharedModule,
    AppRoutingModule,
    W4formModule,
    FontAwesomeModule,
    UserIdleModule.forRoot(userIdleConfig),
  ],
  providers: [
    ConfirmationService,
    {
      provide: CreNgConfig,
      useValue: creNgConfig,
    },
    {
      provide: UserIdleConfig,
      useValue: userIdleConfig,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RestInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
